document.addEventListener('click', (e) => {
  const btn = e.target.closest('.scroll-on-section-el');
  if (!btn) return;

  e.preventDefault();

  const targetClass = btn.dataset.scroll;
  if (!targetClass) return;

  const targetEl = document.querySelector(`.${targetClass}`);

  // Same page
  if (targetEl) {
    targetEl.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    return;
  }

  // Different page
  localStorage.setItem('scrollTargetClass', targetClass);

  const url =
    btn.getAttribute('href') ||
    window.location.pathname;

  window.location.href = url;
});

document.addEventListener('DOMContentLoaded', () => {
  const targetClass = localStorage.getItem('scrollTargetClass');

  if (!targetClass) return;

  const targetEl = document.querySelector(`.${targetClass}`);

  if (targetEl) {
    setTimeout(() => {
      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      localStorage.removeItem('scrollTargetClass');
    }, 300);
  }
});


